import { map } from 'lodash'
import { useCallback, useMemo } from 'react'
import { graphql, useFragment, useMutation } from 'react-relay'

import {
  type useBeliefSystemCriteria_query$data,
  type useBeliefSystemCriteria_query$key
} from '@/__generated__/useBeliefSystemCriteria_query.graphql'
import { type useBeliefSystemCriteriaMutation } from '@/__generated__/useBeliefSystemCriteriaMutation.graphql'

type CommitAsyncFn = (beliefSystemIds: string[]) => Promise<useBeliefSystemCriteria_query$data>

export const useBeliefSystemCriteria = (
  queryRef?: useBeliefSystemCriteria_query$key | null | undefined
): [string[], CommitAsyncFn, boolean] => {
  const queryData = useFragment(
    graphql`
      fragment useBeliefSystemCriteria_query on Query {
        currentUser {
          beliefSystemCriteria(orderBy: [BELIEF_SYSTEM_BY_BELIEF_SYSTEM_ID__SEQUENCE_ASC]) {
            nodes {
              beliefSystemId
            }
          }
        }
      }
    `,
    queryRef
  )
  const data = useMemo(
    () => map(queryData?.currentUser?.beliefSystemCriteria.nodes, 'beliefSystemId'),
    [queryData?.currentUser?.beliefSystemCriteria.nodes]
  )
  const [commit, isPending] = useMutation<useBeliefSystemCriteriaMutation>(graphql`
    mutation useBeliefSystemCriteriaMutation($input: UpdateBeliefSystemCriteriaInput!) {
      updateBeliefSystemCriteria(input: $input) {
        query {
          ...useBeliefSystemCriteria_query
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (beliefSystemIds: string[]) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              // @ts-ignore false negative
              resolve(response)
            }
          },
          variables: {
            input: {
              beliefSystemIds
            }
          }
        })
      ),
    [commit]
  )

  return [data, commitAsync, isPending]
}
